import type { ReactNode } from 'react';

/**
 * Cabecalho de pagina (v2.1, p.34): sobretitulo, titulo, descricao e acoes a
 * direita.
 *
 * O sobretitulo diz onde voce esta no sistema; o H1 diz o que e esta tela; o
 * subtitulo diz o que ela responde. Uma frase, nao um paragrafo — quem abre a
 * tela todo dia le o subtitulo uma vez na vida, e quem abre pela primeira vez
 * precisa dele curto o bastante para de fato ler. A frase QUEBRA em vez de
 * ser cortada com reticencias: em 390 px o "Montado agora" do Painel, que e a
 * data da informacao, sumia no corte (R01, p.28: nada some por largura).
 *
 * Acoes a direita, em ordem de importancia crescente: consulta, secundario e o
 * primario na ponta (p.21). Um `txt-pagina` por tela, e so um: dois H1 e o
 * mesmo que nenhum. Com pouco espaco, os secundarios vao para "Mais ações".
 *
 * QUANDO NAO CABE, AS ACOES DESCEM (R01, p.28). O titulo pede ao menos 320 px;
 * se o titulo e as acoes nao cabem na mesma linha, as acoes vao para a linha
 * de baixo, encostadas a direita, e quebram entre si se preciso. Antes a linha
 * nao quebrava e, em 390 px, os botoes cobriam o H1.
 */
export function CabecalhoPagina({
  sobretitulo,
  titulo,
  subtitulo,
  acoes,
}: {
  /** Modulo ou area. Vai em caixa alta, 11/600 com entreletra (`--txt-sobretitulo`). */
  readonly sobretitulo?: string;
  readonly titulo: string;
  /** Uma frase. Sem ponto final quando nao for frase completa. */
  readonly subtitulo?: string;
  readonly acoes?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-4">
      <div className="flex min-w-0 flex-[1_1_320px] flex-col gap-1">
        {/* O apagado da v2.1 (#736A64) mede 4,7:1 no fundo da pagina. */}
        {sobretitulo ? <span className="txt-sobretitulo text-tinta-apagada">{sobretitulo}</span> : null}
        <h1 className="txt-pagina text-tinta">{titulo}</h1>
        {subtitulo ? <p className="txt-apoio text-pretty text-tinta-secundaria">{subtitulo}</p> : null}
      </div>
      {acoes ? (
        <div className="ml-auto flex max-w-full flex-wrap items-center justify-end gap-2">{acoes}</div>
      ) : null}
    </div>
  );
}
